import styles from "../styles/Home.module.css";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { useAuth } from "@videostream/route-this-login-react";
import { checkRoles } from "@videostream/role-checker";

function Home() {
  const { currentUser, logout } = useAuth();
  const router = useRouter();
  useEffect(() => {
    if (currentUser && checkRoles(currentUser, ["canListTenants:*"])) {
      router.push(`tenants`);
    } else if (
      currentUser &&
      currentUser.TenantId &&
      checkRoles(currentUser, [`canEditTenant:${currentUser.TenantId}`])
    ) {
      router.push(`tenants/${currentUser.TenantId}/Installations`);
    } else {
      logout();
    }
  }, [currentUser, logout, router]);

  if (!currentUser.TenantId) {
    router.push("login");
  }
}

Home.hideNav = true;

export default Home;
